import * as axios from '~/utilities/axios'

export const createUser = (attorneyId, ticketId) => {
  return axios
    .secure()
    .post(`/api/v1/sendbird_chat/createSendbirdChatUser`, { attorneyId, ticketId })
    .then(res => res.data)
    .catch(axios.parseError)
}

export const autoJoinSendbirdUserToHisGroupChannel = (attorneyId, ticketId) => {
  return axios
      .secure()
      .put(`/api/v1/sendbird_chat/autoJoinSendbirdUserToHisGroupChannel`, { attorneyId, ticketId })
      .then(res => res.data)
      .catch(axios.parseError)
}

export const historyForGroupChannel = (ticketId) => {
  return axios
      .secure()
      .get(`/api/v1/sendbird_chat/historyForGroupChannel/${ticketId}`)
      .then(res => res.data)
      .catch(axios.parseError)
}
